import * as VisitorTracking from '../visitorTracking';
import * as DynamicContentLoader from "../dynamicContentLoader";

export function initializeSchedule() {

        function safeInitModal(elementId) {
            const element = document.getElementById(elementId);
            if (element) {
                return new Modal(element);
            }
            return null;  // Return null if element is not found
        }

        const enrollmentModal = safeInitModal('zoniModal');

    document.querySelectorAll('button.zahs-admission-schedule').forEach(button => {
        button.addEventListener('click', () => {
        // 1) hide any other open modals
        document.querySelectorAll('.modal.show').forEach(modal => {
            Modal.getInstance(modal).hide();
        });

        // 2) adjust modal for the admission meeting context
        VisitorTracking.customizeForSchoolAdmissionMeeting();
        const parts = [
            document.getElementById("first_name")?.value || "",
            document.getElementById("middle_name")?.value || "",
            document.getElementById("last_name")?.value || ""
        ];

        const fullName = parts.filter(Boolean).join(" ");

        document.getElementById("full_name").setAttribute("value", fullName);

        document.getElementById("email").setAttribute("value",  document.getElementById("student_email")?.value || "");
        const iti = window['iti'];
        if (iti) {
            iti.setNumber(DynamicContentLoader.getPhoneNumber('itiApplication'));
            document.getElementById("intl_phone_id").setAttribute("value", document.getElementById("student_phone_number")?.value || "");
        }

        // 3) finally pop it up
        enrollmentModal.show();
        });
    });
}